import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useGlobalStorageContext } from '../contexts/GlobalStorageContext';
import { GOOGLE_MAPS_API_KEY } from '../config/googleMaps';
import './MasjidPage.css';

declare global {
  interface Window {
    google: any;
  }
}

const MASJIDS = {
  masjids: [
    {
      city: 'Espoo',
      children: [
        { name: 'Kivenlahden moskeija', address: 'Jälkimaininki 4, Espoo', phone: '', location: 'https://goo.gl/maps/fMnTSaDoxADD6xAH8', email: '', facebook: '', url: '' },
        { name: 'Masjid Al -ikhlaas', address: 'Harakantie 20 Leppävaaraa, Espoo', phone: '', location: 'Harakantie 20 Leppävaaraa, Espoo', email: '', facebook: '', url: '' },
        { name: 'Masjid AL-Nuur', address: 'Kirstinharju 1-3,Espoo, 02760, FINLAND', phone: '+358456496900', location: 'Kirstinharju 1-3,Espoo, 02760, FINLAND', email: 'info@masjidalnuur.com', facebook: 'https://www.facebook.com/masjidalnuurEspoo', url: 'http://www.masjidalnuur.com' },
        { name: 'Olari Masjid', address: 'Kuunkehrä 4 C 02210 Espoo, Finland', phone: '', location: 'Kuunkehrä 4 C 02210 Espoo, Finland', email: '', facebook: 'https://www.facebook.com/olarimasjid/', url: '' },
        { name: 'Masjid Abubakarsadik, Matinkylä', address: 'Kalastajamäki 13, 02230 Espoo', phone: '', location: 'Kalastajamäki 13, 02230 Espoo', email: '', facebook: '', url: '' },
        { name: 'Masjid Al Ikhlas, Leppavaara', address: 'Harakantie 20 B, Espoo, 02600', phone: '', location: 'Harakantie 20 B, Espoo, 02600', email: '', facebook: '', url: '' },
        { name: 'Masjid AL-Taqwa', address: 'Tulkinkuja 3,Espoo, FINLAND', phone: '', location: 'Tulkinkuja 3,Espoo, FINLAND', email: '', facebook: '', url: '' },
      ]
    },
    {
      city: 'Helsinki',
      children: [
        { name: 'Masjid Darul Aman', address: 'Hämeentie 78, 00550 Helsinki', phone: '+358409132762', location: 'Hämeentie 78, 00550 Helsinki', email: '-', facebook: 'https://www.facebook.com/groups/459226764447194/', url: 'https://maps.app.goo.gl/KCjs95vnmD6SqBfk8' },
        { name: 'Masjid Malmi (Yusuf Islam Keskus)', address: 'Soidinkuja 1, 00700, Helsinki', phone: '+358415142570', location: 'Soidinkuja 1, 00700, Helsinki', email: '-', facebook: 'https://www.facebook.com/groups/459226764447194/', url: 'https://www.facebook.com/Armahtajan/' },
        { name: 'Masjid Kannelmäki', address: 'Sitratie 7,Kannelmäki, 00420,Helsinki', phone: '', location: 'Sitratie 7,Kannelmäki, 00420,Helsinki', email: '-', facebook: '', url: '' },
        { name: 'Abuubakar Masjid (Puistola)', address: 'Maatullinaukio 2, 00750  Helsinki', phone: '+358451192920', location: 'Maatullinaukio 2, 00750  Helsinki', email: '-', facebook: '', url: '' },
        { name: 'Hidaaya Masjid Malmi', address: 'Malminkaari 5, 00700 Helsinki', phone: '+358409122557, +358406815817', location: 'Malminkaari 5, 00700 Helsinki', email: '-', facebook: '', url: '' },
        { name: 'Suomen Islamilainen Yhdyskunta', address: 'Lönnrotinkatu 22A5, 00120 Helsinki', phone: '+35892782551', location: 'Lönnrotinkatu 22A5, 00120 Helsinki', email: 'rabita@rabita.fi', facebook: '', url: 'https://rabita.fi' },
        { name: 'Masjid al ummah', address: 'Hernepellonkuja 6,  00560 Helsinki', phone: '+358505651646', location: '', email: '-', facebook: '', url: '' },
        { name: 'AL RAHMA ISLAMIC CENTER', address: 'Kastelholmantie 4, Helsinki', phone: '+35893433100', location: '', email: '-', facebook: '', url: '' },
        { name: 'Kosovolainen masjid Dituria', address: 'Pulttitie 14, 00880 Helsinki', phone: '+358405492146', location: '', email: '-', facebook: '', url: '' },
        { name: 'Bangladesh Kendio Masjid', address: 'Sirrikuja 1B 00940 Helsink', phone: '+358451614933', location: 'Sirrikuja 1B 00940 Helsink, FINLAND', email: '', facebook: 'http://www.facebook.com/bangladesh.kendrio.masjid', url: '' },
        { name: 'Masjid Al Huda (Helsinki Islamic Center)', address: 'Veturitori 2,Helsinki, 00520, FINLAND', phone: '+358 451282818', location: 'Veturitori 2,Helsinki, 00520, FINLAND', email: 'info@hic.fi', facebook: '', url: 'http://www.hic.fi' },
        { name: 'Masjid Al-Iman', address: 'Munkkiniemenpuistotie 4 A PL 45 FIN-00331 HELSINKI;FINLAND', phone: '+358 9 241 0526', location: 'Munkkiniemenpuistotie 4 A PL 45 FIN-00331 HELSINKI;FINLAND', email: 'imaninfo@welho.com', facebook: '', url: 'http://www.masjidiman.com' },
        { name: 'Rabita', address: 'Lönnrotinkatu 22A5 00120 Helsinki', phone: '+358 92782551', location: 'Lönnrotinkatu 22A5 00120 Helsinki', email: 'rabita@rabita.fi', facebook: '', url: 'http://www.rabita.fi' },
        { name: 'Helsingin Muslimit (MASJID AT-TAWHIID)', address: 'Viljatie 4 C 20 1kr 00700 Helsinki', phone: '+358 045 882 5681', location: '', email: 'info@helsinginmuslimit.fi', facebook: '', url: 'http://www.helsinginmuslimit.fi/' },
      ]
    },
    {
      city: 'Joensuu',
      children: [
        { name: 'Masjid Islami Joensuu', address: 'Kirkkokatu 16 C 35, 80140 Joensuu', phone: '', location: '', email: '', facebook: 'https://www.facebook.com/share/1AnsveDdZX/?mibextid=wwXIfr', url: '' },
      ]
    },
    {
      city: 'Jyväskylä',
      children: [
        { name: 'Masjid An-Nur', address: 'Vaasankatu 4A, 40100', phone: '+358453140404', location: '', email: 'jyvaskylanmoskeija@gmail.com', facebook: 'https://m.facebook.com/JyvaskylanMoskeija', url: '' },
      ]
    },
    {
      city: 'Oulu',
      children: [
        { name: 'POHJOIS SUOMEN ISLAMILAINEN YHDYSKUNTA', address: 'Linnankatu 23-25, 90100 Oulu, FINLAND', phone: '+358500582371', location: 'Linnankatu 23-25, 90100 Oulu, FINLAND', email: 'amannan56@hotmail.com', facebook: 'https://www.facebook.com/psiy.oulu/', url: 'http://psiy.fi/' },
      ]
    },
    {
      city: 'Seinäjoki',
      children: [
        { name: 'MASJID', address: 'Vapaudentie 28, 1st floor, Seinäjoki, FINLAND', phone: '', location: 'Vapaudentie 28, 1st floor, Seinäjoki, FINLAND', email: '', facebook: '', url: '' },
      ]
    },
    {
      city: 'Tampere',
      children: [
        { name: 'Tampere Islamic Society', address: 'Yliopistonkatu 60 A Tampere 33100 Finland', phone: '+358503235594', location: '', email: 'info@islamtampere.com', facebook: '', url: 'http://www.islamtampere.com' },
      ]
    },
    {
      city: 'Turku',
      children: [
        { name: 'Turun Islamilainen Yhdyskunta', address: 'Yliopistonkatu 7 20520 Turku Finland', phone: '', location: '', email: 'tisy.fi@gmail.com', facebook: '', url: 'http://www.tisy.fi/' },
      ]
    },
    {
      city: 'Vaasa',
      children: [
        { name: 'Vaasan moskeija', address: 'Palosaarentie 66, 65230 Vaasa', phone: '+358465851895', location: 'Palosaarentie 66, 65230 Vaasa', email: '', facebook: '', url: '' },
      ]
    },
    {
      city: 'Vantaa',
      children: [
        { name: 'Masjid Bilal Hakunila', address: 'Kannuskuja 2 II Kerros, 01200 Vantaa', phone: '', location: '', email: '-', facebook: '', url: '' },
        { name: 'Masjid Bilal Lansimäki', address: 'Kuulakuja 1, Vantaa', phone: '+358453573744', location: '', email: '-', facebook: '', url: '' },
        { name: 'Masjid Al-Shifaa - Itävantaan Islaminlainen Yhdyskunta', address: 'Rautkallionkatu PI 14 01360 Vantaa, FINLAND', phone: '+358466344335', location: '', email: 'masjidalalshifaa@hotmail.com', facebook: '', url: '' },
        { name: 'As-salam Islamic Center Community', address: 'Ojahaanrinne 4K 01600 Vantaa, FINLAND', phone: '+358451950139', location: '', email: 'info@assic.fi', facebook: 'https://www.facebook.com/assic.fi', url: 'http://www.assic.fi/' },
        { name: 'Suomen Islamilainen Diyanet Yhdyskunta', address: 'Kilpakuja 1 01280 Vantaa', phone: '+358 44 7022023', location: '', email: 'diyanet.helsinki@hotmail.com', facebook: '', url: 'https://diyanet.fi' },
      ]
    }
  ]
}

export const MasjidPage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useLanguage();
  const { manualLocation } = useGlobalStorageContext();
  const [activeTab, setActiveTab] = useState<'local' | 'search'>('local');
  const [expanded, setExpanded] = useState<Set<string>>(new Set());
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [mapsLoaded, setMapsLoaded] = useState(false);

  useEffect(() => {
    if (activeTab === 'search' && !mapsLoaded && GOOGLE_MAPS_API_KEY) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.onload = () => setMapsLoaded(true);
      document.head.appendChild(script);
    }
  }, [activeTab, mapsLoaded]);

  const toggle = (city: string) => {
    const newSet = new Set(expanded);
    if (newSet.has(city)) {
      newSet.delete(city);
    } else {
      newSet.add(city);
    }
    setExpanded(newSet);
  };

  const handleSearch = async () => {
    if (!searchQuery.trim() || !window.google) return;
    setLoading(true);
    
    try {
      const geocoder = new window.google.maps.Geocoder();
      
      geocoder.geocode({ address: searchQuery }, (geoResults: any, geoStatus: any) => {
        if (geoStatus === 'OK' && geoResults[0]) {
          const location = geoResults[0].geometry.location;
          
          const service = new window.google.maps.places.PlacesService(document.createElement('div'));
          const request = {
            location: location,
            radius: 50000,
            keyword: 'mosque',
            type: 'mosque'
          };

          service.nearbySearch(request, (results: any, status: any) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setSearchResults(results || []);
            } else {
              setSearchResults([]);
            }
            setLoading(false);
          });
        } else {
          setSearchResults([]);
          setLoading(false);
        }
      });
    } catch (error) {
      console.error('Search failed:', error);
      setSearchResults([]);
      setLoading(false);
    }
  };

  return (
    <div className="masjid-page" style={{ backgroundColor: colors.background, color: colors.text }}>
      <div className="masjid-tabs" style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}>
        <button
          className={`masjid-tab ${activeTab === 'local' ? 'active' : ''}`}
          onClick={() => setActiveTab('local')}
          style={{
            color: activeTab === 'local' ? colors.tint : colors.muted,
            borderBottomColor: activeTab === 'local' ? colors.tint : 'transparent'
          }}
        >
          {t.masjid.local}
        </button>
        <button
          className={`masjid-tab ${activeTab === 'search' ? 'active' : ''}`}
          onClick={() => setActiveTab('search')}
          style={{
            color: activeTab === 'search' ? colors.tint : colors.muted,
            borderBottomColor: activeTab === 'search' ? colors.tint : 'transparent'
          }}
        >
          {t.masjid.search}
        </button>
      </div>

      {activeTab === 'local' ? (
        <div className="local-content">
          {MASJIDS.masjids.map((cityData) => (
            <div key={cityData.city} className="city-section">
              <button
                className="city-header"
                onClick={() => toggle(cityData.city)}
                style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}
              >
                <span className="city-title" style={{ color: colors.tint }}>{cityData.city}</span>
                <span>{expanded.has(cityData.city) ? '▲' : '▼'}</span>
              </button>
              
              {expanded.has(cityData.city) && (
                <div className="masjid-list">
                  {cityData.children.map((masjid, i) => (
                    <div key={i} className="masjid-card" style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}>
                      <div className="masjid-icon" style={{ backgroundColor: colors.background }}>🕌</div>
                      <div className="masjid-details">
                        <div className="masjid-name" style={{ color: colors.text }}>{masjid.name}</div>
                        <div className="masjid-address" style={{ color: colors.muted }}>{masjid.address}</div>
                        <div className="masjid-actions">
                          {masjid.location && (
                            <a href={masjid.location} target="_blank" rel="noopener noreferrer" className="action-btn" style={{ color: colors.tint }}>
                              📍 Map
                            </a>
                          )}
                          {masjid.phone && (
                            <a href={`tel:${masjid.phone}`} className="action-btn" style={{ color: colors.tint }}>
                              📞 Call
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="search-content">
          <div className="search-box">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              placeholder={t.masjid.placeholder}
              style={{ backgroundColor: colors.cardBackground, color: colors.text, borderColor: colors.border }}
            />
            <button onClick={handleSearch} disabled={loading} style={{ backgroundColor: colors.tint }}>
              {loading ? t.masjid.searching : '🔍'}
            </button>
          </div>

          {searchResults.length > 0 && (
            <div className="search-results">
              {searchResults.map((result, i) => (
                <div key={i} className="search-result-card" style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}>
                  <div className="result-icon">🕌</div>
                  <div className="result-details">
                    <div className="result-name" style={{ color: colors.text }}>{result.name}</div>
                    <div className="result-address" style={{ color: colors.muted }}>{result.vicinity}</div>
                    {result.rating && (
                      <div className="result-rating" style={{ color: colors.muted }}>⭐ {result.rating}</div>
                    )}
                    <a
                      href={`https://www.google.com/maps/place/?q=place_id:${result.place_id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="result-link"
                      style={{ color: colors.tint }}
                    >
                      {t.masjid.viewOnMaps} →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
